import { SepaTransactionOutput } from '@allocab/allocab-invoice-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchTransaction = (transactionId: string) => {
  return driverApi.get<void, SepaTransactionOutput>(`/v1/transactions/${transactionId}`);
};

export const useFetchTransaction = (transactionId: string) => {
  return useQuery({
    queryKey: queryKeys.user.fetchTransaction(transactionId),
    queryFn: () => fetchTransaction(transactionId),
  });
};
